import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importButtonText: {
		id: 'software-onboarding-invites.import-work-button.import-button-text',
		defaultMessage: 'Import work',
		description: 'Text on import work button',
	},
});
